import { Layers } from "appworks/graphics/layers/layers";
import { AutoSingleWinRadioControl } from "appworks/ui/controls/standard/radio/auto-single-win-radio-control";
import { AutoRadioControlFactory } from "./auto-radio-control-factory";

export class AutoSingleWinRadioControlFactory extends AutoRadioControlFactory {

    constructor(protected trailingDecimals: boolean = true) {
        super();
    }

    public filter(layer: Layers) {
        if (layer.getFlexiButton("single_win_limit_radio_1") && layer.getFlexiText("single_win_limit_radio_1_label")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        const data = this.getButtonsAndLabels(layer, "single_win_limit");

        return [ new AutoSingleWinRadioControl(data.buttons, data.labels,
            layer.getFlexiButton("single_win_limit_radio_left"), layer.getFlexiButton("single_win_limit_radio_right"), this.trailingDecimals) ];
    }
}
